import { SavedView } from '@sprint/sprint-react-components';
import DataGridRequest from './DataGridRequest';
export class OrganisationSavedViewsRequest extends DataGridRequest<SavedView> {
    Url = '/subscribers/lists/api/organisation';
}
